/* eslint-disable react/prop-types */
import React, { useMemo, useState } from "react";
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import { ThemeProvider } from "@mui/material/styles";
import en from '../../nls/en.json';
import { OptionsWrapper, theme } from "../Styles/GoalsStyle";
import { isEmpty } from "../../utils/constants";
import { useSelector } from "react-redux";
import IconMap from "../common/Icon/IconMap";
import { useLocation } from "react-router-dom";

const MajorCategories = ({ getMajorCategories, data, isFromEditMejorCategiries }) => {
  const { savedAnswer, studentProfileIfo } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const location = useLocation();
  const mentorId = location?.state?.mentorId;
  const { ACADEMIC_BACKGROUND } = mentorId ? studentProfileIfo : savedAnswer;
  const defaultvals = !isEmpty(ACADEMIC_BACKGROUND) && ACADEMIC_BACKGROUND?.find(obj => obj?.sub_category_name === 'MAJOR_CATEGORIES')?.options?.map(option => option?.option_id) || [];
  const [majorCategoriesOptions, setmajorCategoriesOptions] = useState(defaultvals);
  const handleOptionChange = (option_id) => {
    if (majorCategoriesOptions.includes(option_id)) {
      setmajorCategoriesOptions((prevSelected) => prevSelected.filter((selected) => selected !== option_id));
    } else {
      if (majorCategoriesOptions.length < 2) {
        setmajorCategoriesOptions((prevSelected) => [...prevSelected, option_id]);
      }
    }
  };

  useMemo(()=>{
    getMajorCategories(majorCategoriesOptions);
  },[majorCategoriesOptions]);
  
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box variant="form">
          {
            !isFromEditMejorCategiries && 
          <Typography variant="h2">
            {en?.MAJORCATEGORIES_TITLE}
          </Typography>
          }
          <OptionsWrapper>
            <Typography variant="h3" sx={{ mb: 0 }}>
              {data?.question_text}<span style={{color: "#DC3545" }}>*</span>
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "12px", color: "#666666" }}
            >

            </Typography>
            <FormGroup sx={{ mt: 2 }}>
              {data?.options?.map((option) => (
                <FormControlLabel
                  key={option?.option_id}
                  control={<Checkbox
                    checked={majorCategoriesOptions.includes(option?.option_id)}
                    onChange={() => handleOptionChange(option?.option_id)}
                  />}
                  label={
                    <React.Fragment>
                       <IconMap iconValue={option?.option_text} />
                      {option?.option_text}
                    </React.Fragment>
                  }
                />
              ))}
            </FormGroup>
          </OptionsWrapper>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MajorCategories;
